<template>
<div class="chapter">
<div class="inner_page">
<div>
<svg height="100%" preserveaspectratio="none" version="1.1" viewbox="0 0 563 751" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<image height="751" width="563" xlink:href="../Images/cover.jpeg"></image>
</svg>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?12123f04